module.exports = __webpack_public_path__ + "assets/img/house-2.403e71a3.png";